import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './client'

/* Retry policy for queries and ordinary mutations lives here. The exam sync is
   deliberately excluded — it retries indefinitely with jittered backoff, and
   owns that logic itself (features/exam/hooks/useAnswerSync.ts). */

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 3 attempts with exponential backoff, but never on a 4xx: a 403 will
        // be a 403 the third time too, and retrying it just delays the error
        // the student needs to see.
        retry(failureCount, error) {
          if (failureCount >= 3) return false
          if (error instanceof ApiError) return error.isRetryable
          return true
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        // A student on a phone loses and regains connectivity constantly;
        // refetching on reconnect is what makes the app feel repaired.
        refetchOnReconnect: true,
      },
      mutations: {
        // No automatic retry — the user retries. An auto-retried mutation is
        // an action performed twice from the user's point of view.
        retry: false,
      },
    },
  })
}
